import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import http from '../config/http-service';

export interface IDedDetailById {
  id: number;
  englishName?: string;
  arabicName?: string;
  pageUrl?: string;
  businessName: string;
  licenseStatus?: string;
  legalType?: string;
  expiryDate?: string;
  activities?: string;
  telephone?: string;
  fax?: string;
  mobile?: string;
  poBox?: string;
  email?: string;
  address?: string;
  area?: string;
  subArea?: string;
  community?: string;
  landmark?: string;
  parcelId?: string;
  street?: string;
  building?: string;
  floor?: string;
  unit?: string;
  gpsCoordinates?: string;
  licenseNumber: string;
  createdAt: string;
  updatedAt: string;
  brandLicense?: {
    id: number;
    brandId: number;
    licenceId: number;
  } | null;
}

const endpoint = 'ums/v1/crm/management/ded/licenses';
export const getDedDetailByIdEndpointIdentifier = endpoint;

type TData = IDedDetailById;
type TError = AxiosError;
type TQueryKey = [typeof endpoint, number];

type Options = Omit<UseQueryOptions<TData, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetDedDetailByIdApi(id: number, options?: Options): ReturnType {
  const isLoggedIn = useIsLoggedIn();
  const queryKey: TQueryKey = [endpoint, id];

  const queryFn = async (): Promise<TData> => {
    const { data } = await http.get(`${endpoint}/${id}`);
    return data;
  };

  return useQueryWrapper(queryKey, queryFn, {
    enabled: isLoggedIn && !!id,
    ...options,
  });
}
